module.exports = __webpack_public_path__ + "img/國網中心.9cd67b33.png";